import fetch, { fetchJson } from 'utils/fetch';

export const getProductsByTask = task =>
  fetchJson(`/pco-manager/products.json?task=${task}`);

export const getToolChoicesByTask = task =>
  fetchJson(`/pco-manager/tool-choices.json?task=${task}`);

export const getAllExternalProducts = (task, complementary) => {
  const taskTypeQS = task ? `?task_type=${task}` : '';
  const complementaryQS = complementary
    ? `&complementary=${complementary}`
    : '';
  return fetchJson(
    '/pco-manager/products/external.json' + taskTypeQS + complementaryQS
  );
};

export const linkProduct = (intervention, pointTask, markerTask, from, to) =>
  fetch(`/pco-manager/interventions/${intervention}/errors/products/link`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    body: JSON.stringify({
      point_task: Number(pointTask),
      marker_task: Number(markerTask),
      from: Number(from),
      to: Number(to),
    }),
  });

export const displayEdit = product =>
  fetch(`/pco-manager/products.json/${product}`).then(res => res.text());

export const getAASTProducts = () =>
  fetchJson(`/pco-manager/aast/products.json`);



// WEBPACK FOOTER //
// ./src/modules/saas/products/api/index.js